/**
 * TanStack Query hooks for `api-driven-report-pull-for-custom-bi-dashboards`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	apiDrivenReportPullForCustomBiDashboardsQueryKeys,
	type CreateApiDrivenReportPullForCustomBiDashboardsBody,
	type ListApiDrivenReportPullForCustomBiDashboardsResponse,
	type ApiDrivenReportPullForCustomBiDashboardsRow,
} from "./api";

export function useApiDrivenReportPullForCustomBiDashboardsList(): UseQueryResult<ListApiDrivenReportPullForCustomBiDashboardsResponse, Error> {
	return useQuery({
		queryKey: apiDrivenReportPullForCustomBiDashboardsQueryKeys.list(),
		queryFn: list,
	});
}

export function useApiDrivenReportPullForCustomBiDashboardsCreate(): UseMutationResult<ApiDrivenReportPullForCustomBiDashboardsRow, Error, CreateApiDrivenReportPullForCustomBiDashboardsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apiDrivenReportPullForCustomBiDashboardsQueryKeys.all });
		},
	});
}

export function useApiDrivenReportPullForCustomBiDashboardsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apiDrivenReportPullForCustomBiDashboardsQueryKeys.all });
		},
	});
}
